const LokalaiDocument = {
  id: "settings",
  title: "Settings",
  subtitle: "Unique dashboard designs 234",
  type: "group",
  icon: "heroicons-outline:squares-plus",
  children: [
    {
      id: "user-interface.tailwindcss",
      title: "TailwindCSS",
      type: "item",
      icon: "heroicons-outline:sparkles",
      url: "/ui/tailwindcss",
    },
    {
      id: "configs",
      title: "Configuration",
      type: "collapse",
      icon: "settings",
      children: [
        {
          id: "default-settings-doc",
          title: "Default Settings",
          type: "item",
          url: "/documentation/configuration/settings",
        },
        {
          id: "fuse-react-routing-doc",
          title: "Routing",
          type: "item",
          url: "/documentation/configuration/routing",
        },
        {
          id: "fuse-react-navigation-doc",
          title: "Navigation",
          type: "item",
          url: "/documentation/configuration/navigation",
        },
      ],
    },
    {
      id: "user-interface.icons",
      title: "Icons",
      type: "collapse",
      icon: "heroicons-outline:bolt",
      url: "/ui/icons",
      children: [
        {
          id: "user-interface.icons.heroicons-outline",
          title: "Heroicons Outline",
          type: "item",
          url: "/ui/icons/heroicons/outline",
        },
        {
          id: "user-interface.icons.heroicons-solid",
          title: "Heroicons Solid",
          type: "item",
          url: "/ui/icons/heroicons/solid",
        },
        {
          id: "user-interface.icons.material-twotone",
          title: "Material Twotone",
          type: "item",
          url: "/ui/icons/material/twotone",
        },
        {
          id: "user-interface.icons.material-outline",
          title: "Material Outline",
          type: "item",
          url: "/ui/icons/material/outline",
        },
        {
          id: "user-interface.icons.material-solid",
          title: "Material Solid",
          type: "item",
          url: "/ui/icons/material/solid",
        },
        {
          id: "user-interface.icons.feather",
          title: "Feather",
          type: "item",
          url: "/ui/icons/feather",
        },
      ],
    },
    {
      id: "user-interface.page-layouts",
      title: "Page Layouts",
      type: "collapse",
      icon: "heroicons-outline:rectangle-group",
      children: [
        {
          id: "user-interface.page-layouts.overview",
          title: "Overview",
          type: "item",
          url: "/ui/page-layouts/overview",
        },
        {
          id: "user-interface.page-layouts.carded",
          title: "Carded",
          type: "collapse",
          children: [
            {
              id: "user-interface.page-layouts.carded.full-width",
              title: "Full Width",
              type: "collapse",
              url: "/ui/page-layouts/carded/full-width",
              children: [
                {
                  id: "user-interface.page-layouts.carded.full-width.overview",
                  title: "Full Width Overview",
                  type: "item",
                  url: "/ui/page-layouts/carded/full-width/overview",
                },
                {
                  id: "user-interface.page-layouts.carded.full-width.normal-scroll",
                  title: "Full Width Normal Scroll",
                  type: "item",
                  url: "/ui/page-layouts/carded/full-width/normal-scroll",
                },
                {
                  id: "user-interface.page-layouts.carded.full-width.page-scroll",
                  title: "Full Width Page Scroll",
                  type: "item",
                  url: "/ui/page-layouts/carded/full-width/page-scroll",
                },
                {
                  id: "user-interface.page-layouts.carded.full-width.content-scroll",
                  title: "Full Width Content Scroll",
                  type: "item",
                  url: "/ui/page-layouts/carded/full-width/content-scroll",
                },
              ],
            },
            {
              id: "user-interface.page-layouts.carded.with-sidebars",
              title: "With Sidebars",
              type: "collapse",
              url: "/ui/page-layouts/carded/with-sidebars",
              children: [
                {
                  id: "user-interface.page-layouts.carded.with-sidebars.overview",
                  title: "With Sidebars Overview",
                  type: "item",
                  url: "/ui/page-layouts/carded/with-sidebars/overview",
                },
                {
                  id: "user-interface.page-layouts.carded.with-sidebars.normal-scroll",
                  title: "With Sidebars Normal Scroll",
                  type: "item",
                  url: "/ui/page-layouts/carded/with-sidebars/normal-scroll",
                },
                {
                  id: "user-interface.page-layouts.carded.with-sidebars.page-scroll",
                  title: "With Sidebars Page Scroll",
                  type: "item",
                  url: "/ui/page-layouts/carded/with-sidebars/page-scroll",
                },
                {
                  id: "user-interface.page-layouts.carded.with-sidebars.content-scroll",
                  title: "With Sidebars Content Scroll",
                  type: "item",
                  url: "/ui/page-layouts/carded/with-sidebars/content-scroll",
                },
              ],
            },
          ],
        },
        {
          id: "user-interface.page-layouts.simple",
          title: "Simple",
          type: "collapse",
          children: [
            {
              id: "user-interface.page-layouts.simple.full-width",
              title: "Full Width",
              type: "collapse",
              url: "/ui/page-layouts/simple/full-width",
              children: [
                {
                  id: "user-interface.page-layouts.simple.full-width.overview",
                  title: "Full Width Overview",
                  type: "item",
                  url: "/ui/page-layouts/simple/full-width/overview",
                },
                {
                  id: "user-interface.page-layouts.simple.full-width.normal-scroll",
                  title: "Full Width Normal Scroll",
                  type: "item",
                  url: "/ui/page-layouts/simple/full-width/normal-scroll",
                },
                {
                  id: "user-interface.page-layouts.simple.full-width.page-scroll",
                  title: "Full Width Page Scroll",
                  type: "item",
                  url: "/ui/page-layouts/simple/full-width/page-scroll",
                },
                {
                  id: "user-interface.page-layouts.simple.full-width.content-scroll",
                  title: "Full Width Content Scroll",
                  type: "item",
                  url: "/ui/page-layouts/simple/full-width/content-scroll",
                },
              ],
            },
            {
              id: "user-interface.page-layouts.simple.with-sidebars",
              title: "With Sidebars",
              type: "collapse",
              url: "/ui/page-layouts/simple/with-sidebars",
              children: [
                {
                  id: "user-interface.page-layouts.simple.with-sidebars.overview",
                  title: "With Sidebars Overview",
                  type: "item",
                  url: "/ui/page-layouts/simple/with-sidebars/overview",
                },
                {
                  id: "user-interface.page-layouts.simple.with-sidebars.normal-scroll",
                  title: "With Sidebars Normal Scroll",
                  type: "item",
                  url: "/ui/page-layouts/simple/with-sidebars/normal-scroll",
                },
                {
                  id: "user-interface.page-layouts.simple.with-sidebars.page-scroll",
                  title: "With Sidebars Page Scroll",
                  type: "item",
                  url: "/ui/page-layouts/simple/with-sidebars/page-scroll",
                },
                {
                  id: "user-interface.page-layouts.simple.with-sidebars.content-scroll",
                  title: "With Sidebars Content Scroll",
                  type: "item",
                  url: "/ui/page-layouts/simple/with-sidebars/content-scroll",
                },
              ],
            },
          ],
        },
        {
          id: "user-interface.page-layouts.empty",
          title: "Empty Page",
          type: "item",
          url: "/ui/page-layouts/empty",
        },
      ],
    },
    {
      id: "user-interface.typography",
      title: "Typography",
      type: "item",
      icon: "heroicons-outline:pencil",
      url: "/ui/typography",
    },
    {
      id: "user-interface.resetNavigation",
      title: "Reset Navigation",
      type: "item",
      icon: "heroicons-outline:arrow-path",
      url: "/documentation/fuse-components/fuse-navigation",
    },
  ],
};
export default LokalaiDocument;
